module.exports = __webpack_public_path__ + "static/seconds-icon-round-small-29e87bdafe0ec452fd13454dac818d77.png";